import { render } from "./FeedbackDetail.vue?vue&type=template&id=102621be&scoped=true"
import script from "./FeedbackDetail.vue?vue&type=script&lang=js"
export * from "./FeedbackDetail.vue?vue&type=script&lang=js"

import "./FeedbackDetail.vue?vue&type=style&index=0&id=102621be&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-102621be"]])

export default __exports__